<button
  aria-label="Close Dialog"
  class="rds-c-snippets-dialog-close-button"
  mat-dialog-close
  mat-icon-button
  matTooltip="Close Dialog"
  i18n-aria-label
  i18n-matTooltip
>
  <mat-icon>close</mat-icon>
</button>
<ng-container *ngIf="generators$ | async as generators; else loadingGenerators">
  <mat-divider class="rds-c-snippets-dialog-close-button-divider"></mat-divider>
  <mat-tab-group (selectedIndexChange)="handleTabChange($event, generators)">
    <mat-tab *ngIf="rawApiQuery$ | async as rawApiQuery" i18n-aria-label aria-label="Raw RDS API Query">
      <ng-template mat-tab-label>
        <mat-icon>code</mat-icon>
      </ng-template>
      <div class="rds-c-snippets-dialog-tab-body-content" fxLayout="column">
        <section class="rds-c-snippets-dialog-library-description-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <p class="mat-body-1" fxFlex i18n>You're a developer now, below is the raw RDS API query.</p>
          <a
            aria-label="Go to the API URL"
            class="rds-c-snippets-link-button"
            mat-icon-button
            target="_blank"
            [attr.href]="rawApiQuery.path"
            matTooltip="Go to the API URL"
            ><mat-icon>open_in_new</mat-icon></a
          >
        </section>
        <mat-divider></mat-divider>
        <rds-c-code-snippet
          fxFlex="auto"
          [html]="rawApiQuery.html"
          [clipboardCode]="rawApiQuery.path"
          clipboardTooltip="Copy the API URL"
          i18n-clipboardTooltip
        ></rds-c-code-snippet>
      </div>
    </mat-tab>
    <mat-tab *ngFor="let generator of generators" [label]="generator.library | uppercase">
      <div class="rds-c-snippets-dialog-tab-body-content" fxLayout="column">
        <section class="rds-c-snippets-dialog-library-description-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <p class="mat-body-1" fxFlex>{{ generator.description || noDescription }}</p>
          <a
            class="rds-c-snippets-link-button"
            mat-icon-button
            target="_blank"
            [attr.href]="generator.url"
            matTooltip="Library's source code"
            ><mat-icon>link</mat-icon></a
          >
        </section>
        <mat-divider></mat-divider>
        <rds-c-versioned-code-snippets
          fxFlex="auto"
          [loading]="loading[generator.library + selected[generator.library]]"
          [loc]="loc[generator.library + selected[generator.library]]"
          [selected]="selected[generator.library]"
          [versions]="generator.supportedVersions"
          (selectionChange)="selectVersion(generator, $event)"
        ></rds-c-versioned-code-snippets>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-container>
<ng-template #loadingGenerators>
  <mat-spinner class="rds-c-snippets-dialog-generators-loader"></mat-spinner>
</ng-template>
